import Vue from "vue";
import VueCompositionAPI, { ref } from "@vue/composition-api";
Vue.use(VueCompositionAPI);

const userInfo = ref(null);
const cites = ref(null);
const brenchs = ref(null);
export const useUser = () => {
    const getUser = async () => {
        let response = null;
        try {
            response = await axios({
                url: "api/user",
            });
            userInfo.value = response.data;

            return response.data;
        } catch (error) {
            console.log(error);
        }
        return response;
    };
    const getCites = async () => {
        let response = null;
        try {
            response = await axios({
                url: "api/cites",
            });
            if (!!response.data.length) {
                cites.value = response.data.map((e) => {
                    return {
                        value: e.id,
                        text: e.title,
                    };
                });
            }
        } catch (error) {
            console.log(error);
        }
        return response;
    };

    const getBrench = async (brench) => {
        let response = null;
        try {
            response = await axios({
                url: "api/brench",
                params: {
                    id: brench,
                },
            });

            if (!!response.data.length) {
                brenchs.value = response.data.map((e) => {
                    return {
                        value: e.id,
                        text: e.name,
                    };
                });
            }
        } catch (error) {
            console.log(error);
        }
        return response;
    };

    const getDebet = async () => {
        let response = null;
        try {
            response = await axios({
                url: "api/debet",
            });

            return response.data;
        } catch (error) {
            console.log(error);
        }
        return response;
    };

    return {
        getUser,
        userInfo,
        getCites,
        cites,
        getBrench,
        brenchs,
        getDebet,
    };
};
